<template>
  <div id="add_article">
    <div v-if="!errMess" class="add_content" :class="{ isService: isService1 }">
      <el-tabs v-model="activeName" v-show="!loadingMeg" class="live_tabs form_tabs" :class='isFullscreen?"form_tabs11":""' ref="tabs" @tab-click="tabClick">
        <template v-for="(item, index) in DataTypeList">
          <el-tab-pane :label="item.baseName" :name="item.baseId+''" class="tab_title">
            <template v-for="index1 in item.itemCount">
              <div :class="index1 == 1
                ? 'infm-group infm-group-top'
                : index1 == item.itemCount
                  ? 'infm-group clear'
                  : 'infm-group'
                ">
                <template v-for="(itemfiled, index2) in item.dataTypes.slice(
                      (index1 - 1) * 6,
                      6 + (index1 - 1) * 6
                    )">
                  <!-- 图片 -->
                  <div class="flex2" v-if="itemfiled.inputCategory == 1">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <b :class="itemfiled.name.length >= 5 ? 'field-t-t' : 'field-t'
                        ">{{ itemfiled.name
  }}<i class="empty"></i></b>
                    </el-tooltip>：
                    <span class="problem_img" v-if="itemfiled.value != null">
                      <template v-if="isArray(itemfiled.value)">
                        <img v-for="(imgurl, i) in JSON.parse(itemfiled.value)" :key="i" style="
                            height: 23px;
                            width: 23px;
                            display: inline-block;
                            border: 1px solid #eee;
                          " v-viewer :src="imgurl" alt="" class="hand" />
                      </template>
                      <template v-else>
                        <img style="
                            height: 23px;
                            width: 23px;
                            display: inline-block;
                            border: 1px solid #eee;
                          " v-viewer :src="itemfiled.value" alt="" class="hand" />
                      </template>
                    </span>
                    <span v-else class="font-grayb">未上传</span>
                  </div>
                  <!-- 文件 -->
                  <div :class="checkValue(itemfiled.value) ? 'flex2' : 'flex3'" v-else-if="itemfiled.inputCategory == 2">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <b :class="itemfiled.name.length >= 5 ? 'field-t-t' : 'field-t'
                        ">{{ itemfiled.name
  }}<i class="empty"></i></b>
                    </el-tooltip>：
                    <template v-if="itemfiled.value != null">
                      <template v-if="isArray(itemfiled.value)">
                        <div style="display: inline-grid">
                          <span v-for="(wjurl, i) in JSON.parse(itemfiled.value)" :key="i" class="wjlist">{{ wjurl
                          }}<el-tooltip class="box-item" effect="dark" content="点击预览" placement="top">
                              <i class="el-icon-view hand" style="margin-left: 5px" @click="PreviewEvt(wjurl)"></i>
                            </el-tooltip></span>
                        </div>
                      </template>
                      <template v-else>
                        <span :class="!checkValue(itemfiled.value) ? '' : 'font-grayb'
                          ">
                          {{
                            checkValue(itemfiled.value)
                            ? "未上传"
                            : itemfiled.value
                          }}</span>
                        <el-tooltip v-if="!checkValue(itemfiled.value)" class="box-item" effect="dark" content="点击预览"
                          placement="top">
                          <i class="el-icon-view hand" style="margin-left: 5px" @click="PreviewEvt(itemfiled.value)"></i>
                        </el-tooltip>
                      </template>
                    </template>
                    <span v-else class="font-grayb">未上传</span>
                  </div>
                  <!-- 开关 -->
                  <div class="flex2" v-else-if="itemfiled.inputCategory == 10">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <b :class="itemfiled.name.length >= 5 ? 'field-t-t' : 'field-t'
                        ">{{ itemfiled.name
  }}<i class="empty"></i></b>
                    </el-tooltip>：
                    <el-switch v-model="itemfiled.value" size="small" disabled active-value="True"
                      inactive-value="False" />
                  </div>
                  <!-- 老师 -->
                  <!-- <div class="flex2" v-else-if="itemfiled.inputCategory == 12">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      placement="bottom"
                      :disabled="
                        itemfiled.tipRemarks == undefined ||
                        itemfiled.tipRemarks == null ||
                        itemfiled.tipRemarks == ''
                          ? true
                          : false
                      "
                    >
                      <div
                        class="content-h"
                        slot="content"
                        v-html="itemfiled.tipRemarks"
                      ></div>
                      <b
                        :class="
                          itemfiled.name.length >= 5 ? 'field-t-t' : 'field-t'
                        "
                        >{{ itemfiled.name
                        }}<i class="empty"></i></b></el-tooltip
                    >：<span
                      :class="
                        checkValue(itemfiled.value) ||
                        stuAdminName(itemfiled.value) == '未设置'
                          ? 'font-grayb'
                          : ''
                      "
                      >{{ stuAdminName(itemfiled.value) }}</span
                    >
                  </div> -->
                  <!-- 标签 -->
                  <div v-else-if="itemfiled.inputCategory == 5" class="flex3">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <b class="field-t-t">{{ itemfiled.name
                      }}<i class="empty"></i></b>
                    </el-tooltip>：
                    <template v-if="!checkValue(itemfiled.value)">
                      <el-tag style="margin-right: 4px" v-for="tag in JSON.parse(itemfiled.value)" :key="tag">{{ tag }}
                      </el-tag>
                    </template>
                    <span v-else class="font-grayb"> 未设置 </span>
                  </div>
                  <!-- 备注 -->
                  <div class="flex3" v-else-if="itemfiled.inputCategory == 13">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <div class="table_style peizhu">
                        {{ itemfiled.name }}：
                      </div>
                    </el-tooltip>
                    <div class="" v-if="!checkValue(itemfiled.value) && JSON.parse(itemfiled.value).length > 0">
                      <el-table :data="JSON.parse(itemfiled.value)" style="width: 100%">
                        <el-table-column prop="CreateTime" label="日期" width="200" :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            <span>{{ scope.row.CreateTime | timefilters }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="AdminId" label="操作人" width="180" :show-overflow-tooltip="true">
                          <template slot-scope="scope">
                            <span
                              v-if="(scope.row.AdminName != '未设置' && scope.row.AdminName != null && scope.row.AdminName != '')">
                              {{ scope.row.AdminName }}
                            </span>
                            <span v-else class="gray">未设置</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="Contents" label="内容" :show-overflow-tooltip="true">
                        </el-table-column>
                      </el-table>
                    </div>
                    <span v-else class="font-grayb peizhu">暂无备注</span>
                  </div>
                  <!-- 状态标签 -->
                  <div class="flex2" v-else-if="itemfiled.fieldName == 'State'">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <b :class="itemfiled.name.length >= 5 ? 'field-t-t' : 'field-t'
                        ">{{ itemfiled.name
  }}<i class="empty"></i></b>
                    </el-tooltip>：<studentStateTagColor v-bind:studentState="converInfo(itemfiled)" :size="'small'">
                    </studentStateTagColor>
                  </div>
                  <!-- 多行文本框 -->
                  <div :class="checkValue(itemfiled.value) ? 'flex2' : 'flex3'" v-else-if="itemfiled.inputCategory == 4">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <b :class="itemfiled.name.length >= 5 ? 'field-t-t' : 'field-t'
                        ">{{ itemfiled.name
  }}<i class="empty"></i></b>
                    </el-tooltip>：<span :class="!checkValue(itemfiled.value) && itemfiled.value != 0
                        ? ''
                        : 'font-grayb'
                      ">
                      <template>{{
                        checkValue(itemfiled.value) || itemfiled.value == 0
                        ? "未填写"
                        : itemfiled.value
                      }}</template>
                    </span>
                  </div>
                  <!-- 日期 -->
                  <div class="flex2" v-else-if="itemfiled.inputCategory == 9">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <b :class="itemfiled.name.length >= 5 ? 'field-t-t' : 'field-t'
                        ">{{ itemfiled.name }}<i class="empty"></i></b>
                    </el-tooltip>：<span :class="!checkValue(itemfiled.value) && itemfiled.value != 0
                      ? ''
                      : 'font-grayb'
                      ">
                      <template>{{
                        checkValue(itemfiled.value) || itemfiled.value == 0
                        ? "未填写"
                        : setTime(itemfiled.value)
                      }}</template>
                    </span>
                  </div>
                  <div :class="!checkValue(itemfiled.value) &&
                        getStringLen(itemfiled.value) > 28
                        ? 'flex3'
                        : 'flex2'
                      " v-else>
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="itemfiled.tipRemarks == undefined ||
                      itemfiled.tipRemarks == null ||
                      itemfiled.tipRemarks == ''
                      ? true
                      : false
                      ">
                      <div class="content-h" slot="content" v-html="itemfiled.tipRemarks"></div>
                      <b :class="itemfiled.name.length >= 5 ? 'field-t-t' : 'field-t'
                        ">{{ itemfiled.name }}<i class="empty"></i></b>
                    </el-tooltip>：<span :class="!checkValue(itemfiled.value) && itemfiled.value != 0
                      ? ''
                      : 'font-grayb'
                      ">
                      <template v-if="isArray(itemfiled.value)"><template v-for="(val, i) in JSON.parse(itemfiled.value)">
                          <!-- {{ val }} -->
                          <el-tag>{{ val }}</el-tag>
                        </template>
                      </template>
                      <template v-else>{{
                        checkValue(itemfiled.value) || itemfiled.value == 0
                        ? "未填写"
                        : itemfiled.value
                      }}</template>
                    </span>
                  </div>

                  <div class="flex2" v-if="itemfiled.fieldName == 'Sourse' && introducerName">
                    <el-tooltip class="item" effect="dark" placement="bottom" :disabled="false">
                      <div class="content-h" slot="content" >推荐人</div>
                      <b class="field-t">推荐人<i class="empty"></i></b>
                    </el-tooltip>：
                    <span>{{introducerName}}</span>
                  </div>
                </template>
              </div>
            </template>

          </el-tab-pane>
        </template>
        <el-tab-pane label="已付费订单" name="four" class="tab_title">
          <div class="tab-pane fade active in">
            <div class="infm-group clear infm-group-top">
              <!-- <p class="peizhu red_font">
                <i class="el-icon-question"></i>
                数据说明：已付费订单数据存在延时现象,延时时间大约在[0到5分钟];即学员订单支付后,相应订单数据同步到当前页面存在延时现象
              </p> -->
              <!-- <div class="table_style peizhu">学员购买订单产品表：</div> -->
              <div v-if="courseClassList.length > 0" class="dTable">
                <el-table :data="courseClassList" height="550" style="width: 100%" stripe border
                  :header-cell-style="{ background: '#f5f7fa' }" class="table_style classList">
                  <el-table-column prop="orderTypeStr" width="110" label="订单类型" :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column prop="courseName" width="300" label="产品名称" :show-overflow-tooltip="true">
                    <template scope="scope">
                      <el-tag v-if="scope.row.isBelong" type="warning" class="m-r">赠品</el-tag>{{
                        scope.row.courseName }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="productTypeStr" label="产品类型" width="110" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <span class="font-grayb" v-if="scope.row.productTypeStr === '请选择'">暂无</span>
                      <span v-else>{{ scope.row.productTypeStr }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="discountMoney" label="价格积分" width="150" :show-overflow-tooltip="true">
                    <template slot-scope="scope" style="font-size: 12px">
                      <span v-if="scope.row.integral > 0" class="live_price">
                        {{ scope.row.integral }}积分
                      </span>
                      <span v-else-if="scope.row.discountMoney <= 0 && scope.row.integral <= 0
                        " class="live_price" style="color: red">免费</span>
                      <span v-else-if="scope.row.originalMoney > scope.row.discountMoney
                        ">原<b>{{ scope.row.originalMoney }}元</b>优惠<b>{{ scope.row.discountMoney }}元</b></span>
                      <span v-else><b>{{ scope.row.discountMoney }}元</b></span>
                      <!-- <span>{{ scope.row.discountMoney }}</span> -->
                    </template>
                  </el-table-column>
                  <el-table-column prop="payMoney" label="实付金额" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <span v-if="scope.row.payMoney">{{ scope.row.payMoney }}元</span>
                      <span v-else class="font-grayb">未设置</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="arrearsMoney" label="欠费金额" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <span v-if="scope.row.arrearsMoney"><span class="red">{{ scope.row.arrearsMoney }}</span>元</span>
                      <span v-else class="font-grayb">未欠费</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="gradeName" label="分配班级" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <span :class="scope.row.gradeName ? '' : 'font-grayb'">{{
                        scope.row.gradeName || "未分配"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="payTime" width="140" label="支付时间" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <span :class="scope.row.payTime ? '' : 'font-grayb'">{{
                        scope.row.payTime || "未设置"
                      }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <span v-else class="font-grayb peizhu">该学员还未下过订单</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <p v-show="loadingMeg" class="err_class">加载中...</p>
    </div>
    <div v-else>
      <p class="err_class">加载失败，请稍后重试...</p>
    </div>
  </div>
</template>

<script>
import { GetStudentCourseAndClassList } from "network/students.js";
import { getStudentDetailNew } from "network/studentsNew.js";
import { isNull, timeFormat, timeFormatNew } from "common/utils";
import studentStateTagColor from "components/studentStateTagColor";
export default {
  name: "StudentDetail",
  props: {
    isService: {
      type: Boolean,
      default: false,
    },
    studentId: {},
    isFullscreen:{}
  },
  components: {
    studentStateTagColor,
  },
  filters: {
    //时间过滤器
    timefilters(val) {
      if (val && val.indexOf("T") != -1) {
        return timeFormatNew(val, "yyyy-MM-dd hh:mm");
      } else if (!val) {
        return "未设置";
      } else {
        return val;
      }
    },
  },
  data() {
    return {
      isService1: this.isService,
      loadingMeg: false,
      activeName: "",
      index: 1,
      errMess: false,
      remarkList: [], //学员备注信息
      courseClassList: [], //购买订单产品表
      defaultImg: require("../../assets/images/face_user.jpg"),
      DataTypeList: [],
      StatesList: [],
      keyword: '',
      introducerName:'',//推荐人
    };
  },
  computed: {
    // 获取管理员身份
    AdminCache() {
      return (
        this.$store.state.AdminCache || sessionStorage.getItem("AdminCache")
      );
    },
    // 格式化学生状态属性名
    converInfo() {
      return (obj) => {
        var statename = this.StatesList.find((f) => f.key == obj.value)?.value;
        obj.studentState = obj.value;
        obj.studentStateStr = statename;
        return obj;
      };
    },
    // 学员备注：列表操作人格式化
    stuAdminName() {
      return (id) => {
        let teacherObj = this.AdminCache.adminInfos || "";
        let obj = teacherObj.find((o) => o.adminId === id * 1);
        if (obj) {
          return obj.adminName;
        } else {
          return "未设置";
        }
      };
    },
  },
  created() {
    if (this.studentId <= 0) {
      this.errMess = true;
      return false;
    }
    this.showForm(this.studentId);
  },
  methods: {
    // 初始化加载表单
    showForm(val) {
      const id = val;
      this.loadingMeg = true;
      const that = this;
      getStudentDetailNew(id).then((res) => {
        if (res.code == 1) {
          this.DataTypeList = res.result.dataTypeBases;
          this.DataTypeList.forEach((f) => {
            f.itemCount = Math.ceil(f.dataTypes.length / 6);
            f.dataTypes.forEach((filed) => {
              filed.tipRemarks =
                filed.tipRemarks != null
                  ? decodeURIComponent(filed.tipRemarks)
                  : filed.tipRemarks;
            });
          });
          this.activeName = this.DataTypeList[0].baseId + '';
          this.StatesList = res.jsonStr;
          this.introducerName = res.result.introducerName;
          setTimeout(() => {
            this.resetTabActivePosition(this.$refs.tabs.$el);
          }, 200);
        } else {
          this.errMess = true;
          this.$alert(res.message,);
          this.$emit("close-dialog");
        }
        this.loadingMeg = false;
      });

      // 查看指定学员报名课程及班级分配接口
      GetStudentCourseAndClassList(id, false, this.keyword).then((res) => {
        if (res && res.code === 1) {
          this.courseClassList = this.sortDataArray(res.result);
        } else {
        }
      });
    },
    sortDataArray(dataArray) {
      return dataArray.sort(function (a, b) {
        return (
          Date.parse(b.payTime ? b.payTime.replace(/-/g, "/") : "") -
          Date.parse(a.payTime ? a.payTime.replace(/-/g, "/") : "")
        );
      });
    },
    //通过动态设置选中的tab宽度、tranform值使下划线选中
    resetTabActivePosition($el) {
      this.$nextTick(() => {
        const activeEl = $el.querySelector(".el-tabs__item.is-active");
        const lineEl = $el.querySelector(".el-tabs__active-bar");
        const style = getComputedStyle(activeEl);
        const pl = style.paddingLeft.match(/\d+/)[0] * 1;
        const pr = style.paddingRight.match(/\d+/)[0] * 1;
        const w = style.width.match(/\d+/)[0] * 1;
        lineEl.style.transform =
          "translateX(" + (activeEl.offsetLeft + pl) + "px)";
        lineEl.style.width = w - pl - pr + "px";
      });
    },
    //tabs切换事件
    tabClick() {
      this.resetTabActivePosition(this.$refs.tabs.$el);
    },
    // 校验是否为空
    checkValue(val) {
      return isNull(val);
    },
    // 判断是否是数组
    isArray(val) {
      var pattern = /\[|\]/g;
      return pattern.test(val);
    },
    getStringLen(val) {
      let pattern = /([\u4e00-\u9fa5]|[\ufe30-\uffa0])/;
      if (pattern.test(val)) {
        var le = val.match(/([\u4e00-\u9fa5]|[\ufe30-\uffa0])/g).length;
        return val.length - le + le * 2;
      } else {
        return val.length;
      }
    },
    // 下载文件
    PreviewEvt(url) {
      window.open(url, "_blank");
    },
    // 格式化备注对象
    RemarkJson(val) {
      let obj = JSON.parse(val);
      let Remarks = [];
      // data.Remarks = JSON.parse(props.inputItem.Value);
      obj.forEach((f) => {
        let remark = {};
        for (var key in f) {
          var value = f[key];
          key = key[0].toLowerCase() + key.slice(1);
          remark[key] = value;
        }
        let date = new Date(remark.createTime);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        var hours =
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var seconds =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        var currentdate =
          year +
          "-" +
          month +
          "-" +
          strDate +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds;
        remark.createTime = currentdate;
        Remarks.push(remark);
      });

      return Remarks;
    },
    //格式化时间
    setTime(row) {
      return timeFormatNew(row, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
<style scoped>
/* 表格tab内容区 */
/deep/.form_tabs .el-tabs__content {
  margin-top: 65px;
  height: calc(100% - 8px);
  overflow: hidden;
}

.red_font {
  color: #f56c6c;
  font-size: 12px;
}

@media screen and (max-height: 768px) {
  #add_article .form_tabs {
    height: 80vh !important;
  }

  .dTable .el-table {
    height: 420px !important;
  }
}

#add_article>>>.el-form-item {
  margin-top: 10px;
}

#add_article>>>.el-tabs .el-tabs__item {
  background-color: #fff;
}

#add_article>>>.el-tabs__nav-wrap::after {
  /* background-color: red; */
  margin-bottom: 0px;
}

#add_article>>>.el-tabs__nav-scroll {
  margin-bottom: 2px;
  width: 100%;
  height: 40px;
  overflow: initial;
}

#add_article>>>.el-tabs__active-bar {
  bottom: -2px;
}

#add_article>>>.el-cascader-panel {
  height: 200px;
  /* width: 132px; */
  line-height: 34px;
  padding: 0 10px;
  z-index: 10;
}

.form_tabs>>>.el-tabs__item {
  border-bottom: none;
}

#add_article>>>.el-table__fixed-right {
  height: 100% !important;
}

/* -----------------01学员管理-学员资料-------------------- */
/* 基本信息 */
.infm-group {
  /* padding: 15px 0; */
  padding-top: 15px;
  border-bottom: 1px dashed #e6eaed;
  font-size: 0;
  overflow: hidden;
}

.infm-group:last-child {
  border-bottom: none;
}

.infm-group-top {
  padding-top: 0;
}

.m-r {
  margin-right: 10px;
}

.none-infm-group {
  border-bottom: none;
}

.infm-group>>>.el-table__body-wrapper {
  /* height: 100px; */
  overflow: auto;
}

.table_style {
  float: left;
  font-size: 12px;
  color: #88898d;
}

.classList {
  max-height: 550px;
  overflow-y: auto;
}

.clear {
  overflow: hidden;
}

.peizhu {
  line-height: 38px;
  font-size: 14px;
}

.err_class {
  text-align: center;
  padding-top: 50px;
}

.wjstyle {
  float: left;
}

.wjlist {
  display: block;
}

.wjlist1 {
  margin-left: 62px;
}

.flex2 {
  float: left;
  height: 40px;
  padding-bottom: 15px;
  width: 31.33%;
  font-size: 14px;
  white-space: nowrap !important;
  /* display: inline-block !important; */
  /* width: 180px !important; */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.flex3 {
  clear: both;
  width: 100%;
  font-size: 14px;
  /* padding: 15px 0; */
  /* padding-bottom: 15px; */
  overflow: hidden;
  margin-bottom: 15px;
  /* border-top: 1px dashed rgba(233, 233, 233, 0.9); */
  /* border-bottom: 1px dashed rgba(233, 233, 233, 0.9); */
}

.flex4 {
  clear: both;
  width: 100%;
  font-size: 14px;
  padding-bottom: 15px;
  overflow: hidden;
  margin-bottom: 15px;
  border-bottom: 1px dashed rgba(233, 233, 233, 0.9);
}

.field-t {
  display: inline-block;
  width: 62px;
  overflow: hidden;
  text-align: justify;
  vertical-align: top;
  height: 20px;
  line-height: 20px;
  font-weight: normal;
  color: #88898d;
  white-space: normal;
}

.field-t .empty {
  display: inline-block;
  width: 100%;
  height: 0;
}

.field-t-t {
  width: 90px;
  color: #88898d;
  line-height: 20px;
  font-weight: normal;
  white-space: pre;
}

.font-grayb {
  color: #c2c7cc;
  font-weight: 500;
}
</style>
<style>
/* 学员状态标签展示 0-8*/
.student_tag_yellow {
  color: #e6a23c !important;
  background-color: #fdf6ec !important;
  border-color: #f5dab1 !important;
}

.student_tag_gray {
  color: #909399 !important;
  background: #f4f4f5 !important;
  border-color: #d3d4d6 !important;
}

.student_tag_red {
  color: #f56c6c !important;
  background: #fef0f0 !important;
  border-color: #fbc4c4 !important;
}

.student_tag_blue {
  color: #409eff !important;
  background: #ecf5ff !important;
  border-color: #b3d8ff !important;
}

.student_tag_green {
  color: #67c23a !important;
  background: #f0f9eb !important;
  border-color: #c2e7b0 !important;
}

.flex2 span {
  /* white-space: nowrap !important;
    display: inline-block !important;
    width: 180px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    line-height: 0.9; */
}

#add_article .form_tabs {
  height: 60vh !important;
}
#add_article .form_tabs11 {
  height: 86.5vh !important;
}

</style>
